var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-satellite","title":"Spotřebiče"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('SuccessLinkButton',{attrs:{"to":{ name: 'appliance_planning_map'},"icon":"fad fa-map-marked-alt","text":"Mapa plánovaných oprav"}})]},proxy:true}])}),_c('ApplianceGrid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }